import { render, staticRenderFns } from "./DictEdit.vue?vue&type=template&id=4d58507f&"
import script from "./DictEdit.vue?vue&type=script&lang=js&"
export * from "./DictEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports